<app-navbar-style-three></app-navbar-style-three>
<!-- Carousel Start -->
<div aria-hidden="true" *ngIf="loadingData" class="col-lg-12 col-md-12 child carousel-inner placeholder-glow">
    <span class="placeholder col-12" style="height: 600px; width: 100%"></span>
</div>
<div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3500"
    *ngIf="!loadingData && slides.length != 0">
    <div class="carousel-inner">
        <div *ngFor="let slide of slides; let i = index" class="carousel-item main-carousel fist-carousel"
            [class.active]="i === 0" data-bs-interval="3500">
            <img [src]="slide.ImageLink" class="d-block w-100 h-100 imgH" alt="Slide {{ i + 1 }}" />
            <!-- <div class="carousel-caption d-none d-md-block">
        <p style="color: white">{{ slide.caption }}</p>
      </div> -->
        </div>
    </div>
    <div class="custom-carousel-controls">
        <button class="carousel-control-prev custom-ctrl-btn" type="button" data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev">
            <i class="fa fa-angle-left"></i>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next custom-ctrl-btn" type="button" data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next">
            <i class="fa fa-angle-right"></i>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
</div>
<!-- Carousel End -->

<!-- GB Messages / Governing Body Start -->
<section class="gb-section" id="gb-section-skeleton" *ngIf="loadingData">
    <div class="gb-grid placeholder-glow">
        <article class="gb-card" *ngFor="let i of [1,2,3]">
            <div class="gb-card__header">
                <h3 class="placeholder col-6"></h3>
            </div>
            <div class="gb-card__photo">
                <div class="placeholder rounded-circle"
                    style="width: 140px; height: 140px; margin: 0 auto; display: block;"></div>
            </div>
            <p class="gb-card__name"><span class="placeholder col-8"></span></p>
            <p class="gb-card__desig"><span class="placeholder col-6"></span></p>
            <div class="gb-card__wave"></div>
            <a class="gb-card__btn disabled placeholder col-4"></a>
        </article>
    </div>
</section>

<section class="gb-section" id="gb-section" *ngIf="!loadingData && GBMessageShown?.length > 0">

    <!-- Dew drop canvas -->
    <canvas id="dew-canvas"></canvas>

    <!-- Flowing ribbon background -->
    <svg class="gb-bg" viewBox="0 0 1000 480" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        <!-- multiple diagonal flowing silk curves -->
        <path d="M-60,40  Q200,-10 420,55  T820,20  T1060,40" stroke="#a8d4ef" stroke-width="2.8" fill="none"
            opacity=".68" />
        <path d="M-60,85  Q180,38  400,98  T800,65  T1060,82" stroke="#a8d4ef" stroke-width="2" fill="none"
            opacity=".54" />
        <path d="M-60,135 Q220,85  450,148 T840,112 T1060,130" stroke="#b8dcf2" stroke-width="2.2" fill="none"
            opacity=".50" />
        <path d="M-60,185 Q200,138 430,196 T820,162 T1060,180" stroke="#a8d4ef" stroke-width="1.6" fill="none"
            opacity=".44" />
        <path d="M-60,235 Q230,190 460,245 T850,210 T1060,230" stroke="#b8dcf2" stroke-width="2" fill="none"
            opacity=".40" />
        <path d="M-60,285 Q215,240 448,294 T838,260 T1060,280" stroke="#a8d4ef" stroke-width="1.5" fill="none"
            opacity=".36" />
        <path d="M-60,340 Q240,296 475,348 T860,314 T1060,335" stroke="#b8dcf2" stroke-width="1.3" fill="none"
            opacity=".32" />
        <path d="M-60,395 Q260,352 500,402 T875,368 T1060,390" stroke="#a8d4ef" stroke-width="1.1" fill="none"
            opacity=".26" />
        <path d="M-60,448 Q280,406 520,456 T890,422 T1060,444" stroke="#c2e2f5" stroke-width="1" fill="none"
            opacity=".22" />
        <!-- soft blobs for depth -->
        <circle cx="890" cy="48" r="115" fill="#cae4f5" opacity=".17" />
        <circle cx="55" cy="430" r="95" fill="#cae4f5" opacity=".14" />
        <circle cx="500" cy="240" r="180" fill="#d5ebf8" opacity=".09" />
    </svg>

    <div class="gb-grid">
        <article class="gb-card" *ngFor="let gb of GBMessageShown; let i = index">
            <div class="gb-card__header">
                <h3>{{ formatGbTitle(gb) }}</h3>
            </div>
            <div class="gb-card__photo">
                <img [src]="gb.GBImagePath" [alt]="gb.GBName" onerror="this.style.display='none'">
            </div>
            <p class="gb-card__name">{{ gb.GBName }}</p>
            <p class="gb-card__desig">{{gb.Rank}}</p>
            <div class="gb-card__wave">
                <svg viewBox="0 0 300 74" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0,36 C28,14 62,50 102,30 C142,10 182,46 228,26 C258,13 282,32 300,24 L300,74 L0,74 Z"
                        fill="#7dd6ee" opacity=".44" />
                    <path d="M0,46 C26,26 60,56 98,38 C136,20 176,53 220,36 C252,22 280,42 300,34 L300,74 L0,74 Z"
                        fill="#2a7fb5" opacity=".70" />
                    <path d="M0,57 C32,40 72,63 118,52 C162,40 202,60 252,50 C270,46 286,54 300,50 L300,74 L0,74 Z"
                        fill="#1b4f7c" />
                </svg>
            </div>
            <a class="gb-card__btn" [routerLink]="['/administration', getGbRoute(gb)]">Speech</a>
        </article>
    </div>
</section>
<!-- GB Messages / Governing Body End -->


<!-- welcome & youtube start -->
<section class="welcome-social-section" style="padding: 44px 32px 44px;" *ngIf="loadingData">
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 28px;"
        class="placeholder-glow">
        <!-- Welcome Skeleton -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area welcome-section flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="text-align: center;">
                        <span class="placeholder col-8"></span>
                    </h3>
                    <p style="flex-grow: 1;">
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-8"></span>
                    </p>
                </section>
            </div>
        </div>
        <!-- YouTube Skeleton -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area social-media-section flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="text-align: center;">
                        <span class="placeholder col-8"></span>
                    </h3>
                    <div class="layer mt-4 video-container flex-grow-1 d-flex flex-column justify-content-center">
                        <div class="placeholder col-12" style="height: 315px; border-radius: 8px;"></div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>

<section class="welcome-social-section" style="padding: 44px 32px 44px;" *ngIf="!loadingData">
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 28px;">
        <!-- Welcome Column -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area welcome-section flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="color: #327ab5; text-align: center;">
                        Cantonment Public School And College BUSMS
                    </h3>
                    <ng-container *ngIf="HomeContent && HomeContent.length > 0">
                        <p style="color: black; text-align: justify !important; flex-grow: 1;" data-aos="zoom-in">
                            <ng-container *ngIf="showFullContent; else partialContent">
                                <span [innerHTML]="HomeContent[0].DetailsEn"></span>
                                <br />
                                <button (click)="toggleShowContent()" class="btn readMoreLess-btn mt-3">
                                    Read Less
                                </button>
                            </ng-container>
                            <ng-template #partialContent>
                                <span [innerHTML]="truncateText(HomeContent[0].DetailsEn, 600)"></span>
                                <br />
                                <button (click)="toggleShowContent()" class="btn readMoreLess-btn mt-3">
                                    Read More
                                </button>
                            </ng-template>
                        </p>
                    </ng-container>
                </section>
            </div>
        </div>

        <!-- YouTube Column -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area social-media-section flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="color: #327ab5; text-align: center;">
                        cpscbusms in Social Media
                    </h3>
                    <div class="layer mt-4 video-container flex-grow-1 d-flex flex-column justify-content-center">
                        <div id="socialSlider" class="carousel slide csWidth mx-auto w-100" data-ride="carousel"
                            data-interval="false">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div
                                        class="carousel-video-inner embed-responsive embed-responsive-16by9 videowrapper">
                                        <iframe width="100%" height="315"
                                            src="https://www.youtube.com/embed/Sm0QJZ6rppE?si=Zfjoa9rcSWs-kSQK"
                                            title="YouTube video player" frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowfullscreen></iframe>
                                    </div>
                                </div>
                            </div>

                            <button class="carousel-control-prev" type="button" data-bs-target="#socialSlider"
                                data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"
                                    style="filter: invert(1);"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#socialSlider"
                                data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"
                                    style="filter: invert(1);"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>
<!-- welcome & youtube end -->


<!-- notice facebook & ad start -->
<section class="welcome-social-section mt-5" style="padding: 44px 32px 44px;" *ngIf="loadingData">
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 28px;"
        class="placeholder-glow">
        <!-- Notice Skeleton -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="text-align: center;">
                        <span class="placeholder col-6"></span>
                    </h3>
                    <div class="flex-grow-1" style="max-height: 400px; overflow: hidden;">
                        <ul class="m-0 p-0" style="list-style: none;">
                            <li *ngFor="let i of [1,2,3]" class="d-flex align-items-center mb-3 p-3 rounded"
                                style="border: 1px solid #e2e8f0;">
                                <div class="placeholder rounded me-3 flex-shrink-0" style="width: 70px; height: 70px;">
                                </div>
                                <div class="flex-grow-1 min-w-0">
                                    <div class="mb-1"><span class="placeholder col-10"></span></div>
                                    <div><span class="placeholder col-4"></span></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        </div>
        <!-- Ad Skeleton -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="text-align: center;">
                        <span class="placeholder col-6"></span>
                    </h3>
                    <div class="flex-grow-1 d-flex flex-column">
                        <div class="w-100 text-center flex-grow-1 d-flex flex-column justify-content-center align-items-center"
                            style="border-radius: 16px; border: 1px solid #7dd3fc; height: 100%;">
                            <div class="placeholder col-10" style="height: 320px; border-radius: 12px; width: 100%;">
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>

<section class="welcome-social-section mt-5" style="padding: 44px 32px 44px;" *ngIf="!loadingData">
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 28px;">
        <!-- Notice Column -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="color: #327ab5; text-align: center;">
                        Notices
                    </h3>
                    <article class="item flex-grow-1" style="overflow: hidden;">
                        <div class="notice-scroll-container">
                            <div class="notice-scroll-track" [style.animation-duration]="scrollAnimationDuration">
                                <div *ngFor="let item of displayNotices"
                                    class="d-flex align-items-center mb-3 p-3 rounded notice-card-item"
                                    style="background: linear-gradient(135deg, #f8fcfd 0%, #eef5fb 100%); border: 1px solid #e2e8f0; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); cursor: pointer;"
                                    (click)="onNavigate(item.FileLink)">
                                    <div class="text-center rounded overflow-hidden me-3 flex-shrink-0"
                                        style="width: 70px; border: 1px solid #e2e8f0;">
                                        <div
                                            style="background-color: #020689; color: #ffffff; padding: 6px 0; font-size: 20px; font-weight: 700; line-height: 1;">
                                            {{ item.CreatedDate | date : "dd" }}
                                        </div>
                                        <div
                                            style="background-color: #f1f5f9; color: #0f172a; padding: 4px 0; font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">
                                            {{ item.CreatedDate | date : "MMM" }}
                                        </div>
                                    </div>
                                    <div class="flex-grow-1 min-w-0" style="min-width: 0;">
                                        <div class="mb-1"
                                            style="font-size: 16px; font-weight: 600; color: #1e293b; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; line-height: 1.4;">
                                            {{ item.EnglishTitle }}
                                        </div>
                                        <div style="font-size: 14px; font-weight: 500; color: #3b82f6;">
                                            View Notice <i class="fa fa-arrow-right ms-1"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <div class="mt-auto text-end" style="padding-top: 15px;">
                        <a href="/notice" class="viewAll"><i class="fa fa-bars"></i> View All</a>
                    </div>
                </section>
            </div>
        </div>

        <!-- Ad Column -->
        <div class="d-flex flex-column">
            <div class="widget-area custom-widget-area flex-grow-1 h-100">
                <section class="widget widget_karlson_posts_thumb h-100 d-flex flex-column">
                    <h3 class="widget-title" style="color: #327ab5; text-align: center;">
                        Admission Open
                    </h3>
                    <div class="flex-grow-1 d-flex flex-column">
                        <a routerLink="/admission-details" class="d-block w-100 text-center flex-grow-1"
                            style="text-decoration: none;">
                            <div style="background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%); padding: 20px; border-radius: 16px; box-shadow: 0 10px 25px rgba(14, 165, 233, 0.15); border: 1px solid #7dd3fc; transition: transform 0.3s ease; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;"
                                onmouseover="this.style.transform='scale(1.02)'"
                                onmouseout="this.style.transform='scale(1)'">
                                <img src="/assets/img/school/IMG-20260701-WA0008.jpg"
                                    style="width: 100%; max-height: 320px; border-radius: 12px; box-shadow: 0 8px 20px rgba(0,0,0,0.15);"
                                    alt="Admission Notice" />
                                <div class="mt-4 mb-2">
                                    <span
                                        style="background-color: #020689; color: white; padding: 10px 24px; border-radius: 30px; font-weight: 600; font-size: 15px; letter-spacing: 0.5px; box-shadow: 0 4px 12px rgba(2, 6, 137, 0.3);">
                                        View Details <i class="fa fa-arrow-right" style="margin-left: 6px;"></i>
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>

<!-- notice facebook & ad end -->

<!-- Start News & Events -->
<section class="welcome-social-section mt-5" style="padding: 44px 32px 44px;" *ngIf="loadingData">
    <div class="placeholder-glow">
        <div class="section-header-row">
            <h3 class="widget-title"><span class="placeholder col-4"></span></h3>
            <span class="placeholder col-2 p-2"></span>
        </div>
        <hr />
        <div class="row gx-2">
            <div *ngFor="let i of [1,2,3]" class="col-12 col-sm-6 col-lg-4 d-flex">
                <div class="achievement-card w-100 mb-2">
                    <div class="achievement-img-wrapper placeholder" style="height: 240px; width: 100%;"></div>
                    <div class="achievement-card-body">
                        <h5 class="achievement-title"><span class="placeholder col-10"></span><span
                                class="placeholder col-8"></span></h5>
                        <span class="placeholder col-4 mt-auto"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="welcome-social-section mt-5" style="padding: 44px 32px 44px;" *ngIf="!loadingData">
    <div>
        <div class="section-header-row">
            <h3 class="widget-title section-title-blue">News & Events</h3>
            <a routerLink="/news-and-events" class="view-all-btn">
                VIEW ALL <i class="flaticon-right-arrow"></i>
            </a>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <div id="newsCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3500">
                    <div class="carousel-inner" style="padding: 15px 0;">
                        <div *ngFor="let group of cardGroupsNews; let i = index" class="carousel-item"
                            [ngClass]="{ active: i === 0 }">
                            <div class="row gx-2">
                                <div *ngFor="let item of group" class="col-12 col-sm-6 col-lg-4 d-flex">
                                    <div class="achievement-card w-100 mb-2">
                                        <div class="achievement-img-wrapper" style="height: 240px;">
                                            <img [src]="item.ShowAttachments?.length > 0 ? item.ShowAttachments[0]?.FilePath : 'assets/img/school/sghsc_logo.png'"
                                                [alt]="item.TitleEn" class="achievement-img" />
                                            <div class="achievement-img-overlay"></div>
                                        </div>
                                        <div class="achievement-card-body">
                                            <h5 class="achievement-title"
                                                style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; line-height: 1.5; margin-bottom: 15px;">
                                                {{ item.TitleEn }}</h5>
                                            <a [routerLink]="['/news-and-events', item.Id]"
                                                class="achievement-read-more mt-auto">
                                                Read More »
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Carousel Controls -->
                    <button class="carousel-control-prev" type="button" data-bs-target="#newsCarousel"
                        data-bs-slide="prev"
                        style="width: 40px; height: 40px; background: rgba(2, 6, 137, 0.7); border-radius: 50%; top: 40%; left: -20px; opacity: 1; box-shadow: 0 4px 10px rgba(0,0,0,0.15);">
                        <span class="carousel-control-prev-icon" aria-hidden="true"
                            style="width: 20px; height: 20px;"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#newsCarousel"
                        data-bs-slide="next"
                        style="width: 40px; height: 40px; background: rgba(2, 6, 137, 0.7); border-radius: 50%; top: 40%; right: -20px; opacity: 1; box-shadow: 0 4px 10px rgba(0,0,0,0.15);">
                        <span class="carousel-control-next-icon" aria-hidden="true"
                            style="width: 20px; height: 20px;"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End News & Events -->


<!-- Achievements Section Start -->
<section class="welcome-social-section mt-5" style="padding: 44px 32px 44px;" *ngIf="loadingData">
    <div class="placeholder-glow">
        <div class="section-header-row">
            <h3 class="widget-title"><span class="placeholder col-4"></span></h3>
            <span class="placeholder col-2 p-2"></span>
        </div>
        <hr />
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngFor="let i of [1,2,3]">
                <div class="achievement-card w-100">
                    <div class="achievement-img-wrapper placeholder" style="height: 240px; width: 100%;"></div>
                    <div class="achievement-card-body">
                        <h5 class="achievement-title"><span class="placeholder col-8"></span></h5>
                        <p class="achievement-desc"><span class="placeholder col-12"></span><span
                                class="placeholder col-12"></span></p>
                        <span class="placeholder col-4"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="welcome-social-section mt-5" style="padding: 44px 32px 44px;" *ngIf="!loadingData">
    <div>
        <div class="section-header-row">
            <h3 class="widget-title section-title-blue">Achievements</h3>
            <a routerLink="/achievements" class="view-all-btn">
                VIEW ALL <i class="flaticon-right-arrow"></i>
            </a>
        </div>
        <hr />
        <div class="row" *ngIf="foundAchivements?.length > 0">
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngFor="let item of foundAchivements">
                <div class="achievement-card w-100">
                    <div class="achievement-img-wrapper">
                        <img [src]="item.ShowAttachments?.length > 0 ? item.ShowAttachments[0]?.FilePath : 'assets/img/school/sghsc_logo.png'"
                            [alt]="item.TitleEn" class="achievement-img" />
                        <div class="achievement-img-overlay"></div>
                    </div>
                    <div class="achievement-card-body">
                        <h5 class="achievement-title">{{ item.TitleEn }}</h5>
                        <p class="achievement-desc">{{ truncateText(item.DetailsEn, 100) }}</p>
                        <a [routerLink]="['/achievements', item.Id]" class="achievement-read-more">
                            Read More »
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Achievements Section End -->

<!-- Our Gallery Section Start -->
<section class="welcome-social-section mt-5"
    style="padding: 50px 32px; background: linear-gradient(135deg, #f0f8ff 0%, #e6f2ff 100%); border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); border: 1px solid #dceeff;"
    *ngIf="loadingData">
    <div class="placeholder-glow">
        <div class="text-center mb-2">
            <h3 class="widget-title section-title-blue d-inline-block" style="font-size: 34px;">
                <span class="placeholder col-12" style="width: 200px; display: inline-block;"></span>
            </h3>
        </div>
        <p class="text-center mb-5"><span class="placeholder col-4"></span></p>

        <div class="gallery-toggle-wrapper text-center mb-5" style="display: flex; justify-content: center; gap: 10px;">
            <span class="placeholder col-2 p-4 rounded-pill" style="width: 140px;"></span>
            <span class="placeholder col-2 p-4 rounded-pill" style="width: 140px;"></span>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngFor="let i of [1,2,3]">
                <div class="gallery-card w-100">
                    <div class="gallery-img-wrapper placeholder" style="height: 240px; width: 100%;"></div>
                    <div class="gallery-card-body">
                        <h6 class="gallery-album-title"><span class="placeholder col-8"></span></h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="welcome-social-section mt-5"
    style="padding: 50px 32px; background: linear-gradient(135deg, #f0f8ff 0%, #e6f2ff 100%); border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); border: 1px solid #dceeff;"
    *ngIf="!loadingData">
    <div>
        <div class="text-center mb-2">
            <h3 class="widget-title section-title-blue d-inline-block"
                style="font-size: 34px; font-weight: 800; text-transform: uppercase; letter-spacing: 1.5px; position: relative; padding-bottom: 10px;">
                Our Gallery
                <span
                    style="position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); width: 60px; height: 4px; background: linear-gradient(90deg, #327ab5, #020689); border-radius: 2px;"></span>
            </h3>
        </div>
        <p class="text-center mb-5" style="color: #666; font-size: 17px; font-weight: 500;">Explore our memorable
            moments through Photos and Videos</p>

        <!-- Photos / Videos Toggle -->
        <div class="gallery-toggle-wrapper text-center mb-5" style="display: flex; justify-content: center; gap: 0;">
            <button *ngFor="let tab of items" class="gallery-toggle-btn"
                [ngClass]="{'gallery-toggle-active': selectedItem === tab}" (click)="selectedItem = tab"
                style="display: flex; align-items: center; justify-content: center; padding: 12px 40px; font-size: 16px;">
                <i class="fa" [ngClass]="tab === 'photos' ? 'fa-image' : 'fa-play-circle'"
                    style="margin-right: 10px; font-size: 18px;"></i>
                {{ tab === 'photos' ? 'Photos' : 'Videos' }}
            </button>
        </div>

        <!-- Photo Albums Grid -->
        <div class="row" *ngIf="selectedItem === 'photos' && ImageAlbumShown?.length > 0">
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngFor="let album of ImageAlbumShown">
                <a [routerLink]="['/imageFolder', album.id || album.Id]"
                    class="gallery-card w-100 text-decoration-none">
                    <div class="gallery-img-wrapper">
                        <img [src]="album.thumbnailLink ? TransformUrl(album.thumbnailLink) : '/assets/img/default_logo.png'"
                            [alt]="album.name || album.Name" class="gallery-img" />
                        <div class="gallery-img-overlay">
                            <i class="fa fa-search-plus"></i>
                        </div>
                    </div>
                    <div class="gallery-card-body">
                        <h6 class="gallery-album-title">{{ album.name || album.Name }}</h6>
                    </div>
                </a>
            </div>
        </div>

        <!-- Video Albums Grid -->
        <div class="row" *ngIf="selectedItem === 'videos' && VideoAlbumShown?.length > 0">
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngFor="let album of VideoAlbumShown">
                <a *ngIf="!album.embedUrl" [routerLink]="['/videoFolder', album.id || album.Id]"
                    class="gallery-card w-100 text-decoration-none">
                    <div class="gallery-img-wrapper gallery-video-wrapper">
                        <img [src]="album.thumbnailLink ? TransformUrl(album.thumbnailLink) : '/assets/img/youtube.png'"
                            [alt]="album.name || album.Name" class="gallery-img" />
                        <div class="gallery-img-overlay">
                            <i class="fa fa-play-circle" style="font-size: 48px;"></i>
                        </div>
                    </div>
                    <div class="gallery-card-body">
                        <h6 class="gallery-album-title">{{ album.name || album.Name }}</h6>
                    </div>
                </a>
                <div *ngIf="album.embedUrl" class="gallery-card w-100 text-decoration-none"
                    style="display: block; cursor: default;">
                    <div class="gallery-img-wrapper gallery-video-wrapper" style="padding: 0; background: #000;">
                        <iframe [src]="album.embedUrl | safe" width="100%" height="100%"
                            style="border: 0; aspect-ratio: 16/9;" allowfullscreen>
                        </iframe>
                    </div>
                    <div class="gallery-card-body">
                        <h6 class="gallery-album-title">{{ album.name || album.Name }}</h6>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-end" style="padding: 10px 0px;">
            <a [routerLink]="selectedItem === 'photos' ? '/photo-gallery' : '/video-gallery'" class="view-all-btn">
                VIEW ALL <i class="flaticon-right-arrow"></i>
            </a>
        </div>
    </div>
</section>
<!-- Our Gallery Section End -->